import React, { Component } from 'react';
import { withRouter } from "tools/routerCompat";
import PropTypes from 'prop-types';
import { MSpinner } from 'components/Shared';
import AppraiserProfileEdit from 'components/Appraiser/AppraiserProfileEdit';

// This is a class-based component because the current
// version of hot reloading won't hot reload a stateless
// component at the top-level.
class AppraiserCreate extends Component {
    constructor(props) {
        super(props);
    }

    UNSAFE_componentWillMount() {
        // dispatcher will call the right end-point
        this.props.getAppraiserProfile('create');
    }
    render() {
        const { fetchingAppraiserProfile, fetchingAppraiserManagers, fetchingStateList } = this.props;

        if (fetchingAppraiserProfile || fetchingAppraiserManagers || fetchingStateList) {
            return <MSpinner />;
        }
        return (
            <div>
                <AppraiserProfileEdit creatingAppraiser={true} />
            </div>
        );
    }
}

AppraiserCreate.propTypes = {
    getAppraiserProfile: PropTypes.func.isRequired,
    fetchingAppraiserProfile: PropTypes.bool.isRequired,
    fetchingAppraiserManagers: PropTypes.bool.isRequired,
    fetchingStateList: PropTypes.bool.isRequired,
};

export default withRouter(AppraiserCreate);
